import React, { useEffect, useState } from 'react';
import {
  Button,
  Typography,
  TextField,
  Checkbox,
  FormControlLabel,
  CircularProgress,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

import { ModalConfirmationDeletedData } from './ModalConfirmationDeletedData';
import { ModalValidationCode } from './ModalValidationCode';

import { confirmDate, maskCPF, maskDate, findIndexInArray } from 'js/library/utils/helpers.js';
import imgIllustration from 'styles/assets/illustration.svg';

import { getUserInfoBasic_v1 } from 'js/library/utils/API/getUserInfo_v1';
import { getSeuClube } from 'js/library/utils/API/getSeuClube';
import { setUserInfo_v1Default } from 'js/library/utils/API/setUserInfo_v1';
import { authCode } from 'js/library/utils/API/authCode.js';

import { toast } from 'react-toastify';

import logoImg from 'styles/assets/Logo_Triibo.png';

import LoadingInfo from './LoadingInfo';
import ErrorMessage from './ErrorMessage';
import StatusMessage from './StatusMessage';

import './stylesDataConfirmation.css';
import cfac22 from 'js/library/utils/cfac22';

export default function DataConfirmation() {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [loading02, setLoading02] = useState(false);
  const [loading03, setLoading03] = useState(false);
  const [userData, setUserData] = useState({});
  const [messageErrorApi, setMessageErrorApi] = useState('');
  const [typeAction, setTypeAction] = useState('');

  const [userCellphone, setUserCellphone] = useState('');
  const [isOpenModalValidationCode, setIsOpenModalValidationCode] = useState(false);
  const [transactionId, setTransactionId] = useState('');
  const [hasCPF, setHasCPF] = useState(false);

  const [fullName, setFullName] = useState('');
  const [nickName, setNickName] = useState('');
  const [cpf, setCpf] = useState('');
  const [birthDate, setBirthDate] = useState('');
  const [email, setEmail] = useState('');
  const [optin1, setOptin1] = useState(true);
  const [optin2, setOptin2] = useState(true);

  const [isDeletedData, setIsDeletedData] = useState(false);
  const [isUpdateData, setIsUpdateData] = useState(false);

  const [isOpenModal, setIsOpenModal] = useState(false);

  const [clubeInfo, setClubeInfo] = useState(null);

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const seuClube = urlParams.get('seuClube');
  const userId = urlParams.get('uId');

  const TITLE = 'Confirme seus dados.';

  // OBS: PEGAR O NOME DO ESTABELECIMENTO QUE VEIO DA USER_V3
  const DESCRIPTION = t('general.you_are_registered_by', {
    establishmentCreatorName:
      userData?.establishmentCreatorName || t('general.registered_establishment_default'),
  });

  const CLUBE_DESCRIPTION = t('general.you_are_registered_by_clube', {
    clubeName: clubeInfo?.name || '',
  });

  useEffect(() => {
    setLoading(true);

    async function getUserData() {
      try {
        let promises = [getUserInfoBasic_v1(['getUserInfo'], { uId: userId })];
        if (seuClube) promises.push(getSeuClube(userId, seuClube));

        const results = await Promise.all(promises);
        const dataUser = results[0];

        if (results[1]) setClubeInfo(results[1]);

        setLoading(false);
        if (dataUser !== null) {
          const userInfo = { ...dataUser };

          let userEmail = '';
          let userCPF = '';

          userInfo.contactList.forEach((contact) => {
            if (contact.type === 'email') {
              userEmail =
                userInfo.contactList[findIndexInArray(dataUser.contactList, 'type', 'email')].value;
            }
          });

          userInfo.documentList.forEach((document) => {
            if (document.type === 'cpf') {
              userCPF =
                userInfo.documentList[findIndexInArray(dataUser.documentList, 'type', 'cpf')].value;
              if (userCPF.length === 0) setHasCPF(false);
              else setHasCPF(true);
            } else {
              setHasCPF(false);
            }
          });

          const userBirthDate = formatDate(dataUser.birthDate);
          const triiboId = userInfo.triiboId;
          const cellphone = triiboId.slice(0, 14);

          setUserCellphone(cellphone);
          setUserData(userInfo);
          setFullName(userInfo.name ?? '');
          setNickName(userInfo.aliasName ?? '');
          setEmail(userEmail);
          setCpf(userCPF ?? '');
          setBirthDate(userBirthDate ?? '');
        } else {
          setMessageErrorApi(t('errors.user_not_found'));
        }
      } catch (error) {
        setLoading(false);
        setMessageErrorApi(t('errors.try_later'));
      }
    }

    getUserData();
  }, [userId, seuClube, t]);

  function sendCode() {
    setLoading02(true);

    authCode(userCellphone, null)
      .then((resultSendSMS) => {
        setLoading02(false);
        if (!resultSendSMS.error) {
          setIsOpenModalValidationCode(true);
          setTransactionId(resultSendSMS.transactionId);
        } else {
          toast.error(t('errors.error_ocurred'));
        }
      })
      .catch((error) => {
        setLoading02(false);
        if (error.errorCode === 1005) {
          toast.warning(t('errors.attempts_exceeded'));
          return;
        }
        toast.error(t('errors.error_ocurred'));
      });
  }

  function formatDate(date) {
    const tempDate = date !== undefined ? new Date(date) : null;
    const formatedDate =
      tempDate === null
        ? ''
        : (tempDate.getDate() >= 10 ? tempDate.getDate() : '0' + tempDate.getDate()) +
          '/' +
          (tempDate.getMonth() + 1 >= 10
            ? tempDate.getMonth() + 1
            : '0' + (tempDate.getMonth() + 1)) +
          '/' +
          tempDate.getFullYear();

    return formatedDate;
  }

  function validatedForm() {
    if (
      fullName.trim() !== '' &&
      nickName.trim() !== '' &&
      cpf.trim() !== '' &&
      birthDate.trim() !== '' &&
      email.trim() !== ''
    ) {
      return true;
    }

    return false;
  }

  function handleDataUser(e, type) {
    e.preventDefault();

    setTypeAction(type);

    if (!optin1) {
      toast.warning(t('errors.agree_terms_and_conditions'));
      return;
    }

    if (!validatedForm()) {
      toast.warning(t('errors.fill_the_fields_correctly'));
      return;
    }

    if (!confirmDate(birthDate)) {
      toast.warning(t('errors.invalid_birth_date'));
      return;
    }

    sendCode();
  }

  function handleDeleteUser(type) {
    setTypeAction(type);
    sendCode();
  }

  //ADICIONA DADOS NA TABELA USERS_V3
  async function addUserData(typeActionModal = '') {
    const triiboId = userData.triiboId;
    const cellphone = triiboId.slice(0, 14);
    //CONVERTE A DATA DE NASCIMENTO
    let userBirthDate = birthDate.split('/');
    userBirthDate = new Date(
      parseInt(userBirthDate[2], 10),
      parseInt(userBirthDate[1] - 1, 10),
      parseInt(userBirthDate[0], 10),
      0,
      0
    ).getTime();

    const currentDate = new Date().getTime();

    //INFORMAÇÕES PARA CHAMAR A API SET_USER_INFO
    const userObj = {
      name: fullName,
      aliasName: nickName,
      birthDate: userBirthDate,
      contactList: [
        {
          type: 'cellPhone',
          value: cellphone,
        },
        {
          type: 'email',
          value: email,
        },
      ],
      documentList: [
        {
          type: 'cpf',
          value: cpf,
        },
      ],
      optInList: [
        {
          type: 'Termos de Uso da Triibo',
          optInId: '-Kzj_F6wDcfHkLMO_q4c',
          version: 1.0,
          dateAcceptance: currentDate,
          accept: optin1,
        },
        {
          type: 'Optin - Termos de consentimento de comunicações opcionais',
          optInId: '-KzjMOHvzce-PUYpoWHU',
          version: 1.0,
          dateAcceptance: currentDate,
          accept: optin2,
        },
      ],
      updateDate: currentDate,
    };

    // API QUE ADICIONA DADOS NO USUÁRIO
    try {
      await setUserInfo_v1Default(userData.uId, ['setUserInfo'], userObj);

      setIsUpdateData(true);
      toast.success(t('general.updated_data'));
      setLoading02(false);

      if (typeActionModal === 'atualizar') {
        toggleModalValitaionCode();
        setLoading03(false);
      }
    } catch (_) {
      setLoading02(false);
      toast.error(t('errors.try_again'));

      if (typeActionModal === 'atualizar') {
        setLoading03(false);
      }
    }
  }

  function toggleModalConfirmationDeleteData() {
    setIsOpenModal(false);
  }

  function toggleModalValitaionCode() {
    setIsOpenModalValidationCode(false);
  }

  if (loading) {
    return <LoadingInfo />;
  } else if (messageErrorApi !== '' && !loading) {
    return <ErrorMessage message={t('errors.try_later')} />;
  }

  return (
    <div className="container-data-confirmation">
      {!isDeletedData && !isUpdateData && (
        <aside style={clubeInfo ? { backgroundColor: clubeInfo.colorPrimary } : {}}>
          <img src={imgIllustration} alt="Imagem formulário" />

          <strong>{TITLE}</strong>
          <p>{clubeInfo ? CLUBE_DESCRIPTION : DESCRIPTION}</p>
        </aside>
      )}

      <main>
        <div className="main-data-confirmation">
          {!isDeletedData && !isUpdateData && (
            <>
              <div className="title-form-data-confirmation">
                <strong>{TITLE}</strong>
                <p>{clubeInfo ? CLUBE_DESCRIPTION : DESCRIPTION}</p>
              </div>
              <img
                style={
                  clubeInfo
                    ? {
                        background: clubeInfo.colorPrimary,
                        borderRadius: 10,
                        padding: 10,
                      }
                    : {}
                }
                src={
                  clubeInfo
                    ? cfac22('STORAGE_URL') + 'seuClube%2F' + clubeInfo.logo + '?alt=media'
                    : logoImg
                }
                alt="Triibo"
              />
            </>
          )}

          {isDeletedData || isUpdateData ? (
            // STATUS DO FINAL DA JORNADA
            <StatusMessage isUpdateData={isUpdateData} />
          ) : (
            <form
              className="data-confirmation-form"
              onSubmit={(e) => handleDataUser(e, 'atualizar')}
            >
              <div className="area-input-data-confirmation">
                <div>
                  <TextField
                    margin="normal"
                    fullWidth
                    required
                    value={fullName}
                    onChange={(e) => setFullName(e.target.value)}
                    type="text"
                    id="name"
                    label={t('labels.full_name')}
                  />
                </div>

                <div>
                  <TextField
                    margin="normal"
                    fullWidth
                    required
                    value={nickName}
                    onChange={(e) => setNickName(e.target.value)}
                    type="text"
                    id="nick-name"
                    label={t('labels.nickname')}
                  />
                </div>
              </div>

              <div className="area-input-data-confirmation">
                <TextField
                  margin="normal"
                  fullWidth
                  required
                  value={maskCPF(cpf)}
                  disabled={hasCPF}
                  onChange={(e) => setCpf(maskCPF(e.target.value))}
                  type="numeric"
                  id="cpf"
                  label={t('labels.cpf')}
                />
                <TextField
                  margin="normal"
                  fullWidth
                  required
                  value={birthDate}
                  onChange={(e) => setBirthDate(maskDate(e.target.value))}
                  type="numeric"
                  id="birth-date"
                  label={t('labels.birth_date')}
                />
              </div>

              <TextField
                fullWidth
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                type="email"
                id="email"
                label={t('labels.email')}
              />

              <div className="area-optin-data-confirmation">
                <div className="content-checkbox-data-confirmation">
                  <FormControlLabel
                    style={{ color: 'rgba(0, 0, 0, 0.54)' }}
                    id="optin1"
                    control={
                      <Checkbox
                        style={clubeInfo ? { color: clubeInfo.colorPrimary } : {}}
                        checked={optin1}
                        onChange={() => setOptin1(!optin1)}
                        value="optin1"
                      />
                    }
                    label={t('general.accept_terms_and_conditions')}
                  />

                  <FormControlLabel
                    style={{ color: 'rgba(0, 0, 0, 0.54)' }}
                    id="optin2"
                    control={
                      <Checkbox
                        style={clubeInfo ? { color: clubeInfo.colorPrimary } : {}}
                        checked={optin2}
                        onChange={() => setOptin2(!optin2)}
                        value="optin2"
                      />
                    }
                    label={t('general.accept_to_receive_communications')}
                  />
                </div>

                <div style={{ padding: '20px 0px' }}>
                  <a href={cfac22('termsOfUseUrl')} target="new">
                    <Typography id="ToS" variant="caption" gutterBottom>
                      <u>{t('general.show_terms_and_conditions')}</u>
                    </Typography>
                  </a>
                </div>
              </div>

              <div className="area-button-data-confirmation">
                <Button
                  disabled={loading02 && !isOpenModalValidationCode && typeAction === 'atualizar'}
                  variant="contained"
                  style={clubeInfo ? { background: clubeInfo.colorPrimary } : {}}
                  color="primary"
                  type="submit"
                  disableRipple
                  fullWidth
                >
                  <Typography style={{ textTransform: 'none' }} variant="h6">
                    {loading02 && !isOpenModalValidationCode && typeAction === 'atualizar' ? (
                      <CircularProgress size="2rem" style={{ color: 'white' }} />
                    ) : (
                      t('general.update_data')
                    )}
                  </Typography>
                </Button>

                {loading02 && !isOpenModalValidationCode && typeAction === 'excluir' ? (
                  <CircularProgress
                    size="2rem"
                    style={{
                      color: clubeInfo ? clubeInfo.colorPrimary : '#6d3196',
                      marginTop: '20px',
                    }}
                  />
                ) : (
                  <span
                    className="area-button__title-link"
                    style={clubeInfo ? { color: clubeInfo.colorPrimary } : {}}
                    onClick={() => handleDeleteUser('excluir')}
                  >
                    {t('general.reques_deletion')}
                  </span>
                )}
              </div>
            </form>
          )}
        </div>
      </main>

      {/* MODAL DE CONFIRMAÇÃO DE EXLUSÃO DE DADOS*/}
      {isOpenModal && (
        <ModalConfirmationDeletedData
          clubeInfo={clubeInfo}
          toggleModal={toggleModalConfirmationDeleteData}
          setStatusData={() => {
            setIsDeletedData(true);
          }}
          open={isOpenModal}
          userInfo={userData}
        />
      )}

      {/* MODAL DE CONFIRMAÇÃO DE CÓDIGO */}
      {isOpenModalValidationCode && (
        <ModalValidationCode
          clubeInfo={clubeInfo}
          typeAction={typeAction}
          setLoading={setLoading03}
          loading03={loading03}
          loading02={loading02}
          addUserData={addUserData}
          sendCode={sendCode}
          transactionId={transactionId}
          toggleModal={toggleModalValitaionCode}
          open={isOpenModalValidationCode}
          userCellphone={userCellphone}
          setIsOpenModal={setIsOpenModal}
        />
      )}
    </div>
  );
}
